
module.exports = {
  apiBase: 'https://api.familysearch.org',
  identBase: 'https://ident.familysearch.org',
  clientId: 'a02j000000BRbI4AAL',
};
